import React from "react";
import "../../../../css/Common/Components/DesignSystem/Buttons.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

/**
 * ButtonYellow is a reusable button component styled with the "Button-Brand3" class.
 * It toggles a "clicked" state on each click and optionally executes a provided onClick handler.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.buttonText - The text to display inside the button.
 * @param {function} [props.onClick] - Optional click handler to execute when the button is clicked.
 * @returns {JSX.Element} The rendered yellow button component.
 */
const ButtonYellow = ({ buttonText, onClick }) => {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();


  return (
    <div
      className={`Button-Brand3 ${clicked ? "clicked" : ""}`}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick();
        onClick && onClick();
      }}
    >
      <div className="Button-Text">{buttonText}</div>
    </div>
  );
};

export default ButtonYellow;
